// extracted by mini-css-extract-plugin
export default {"inlineLoader":"inlineLoader_inlineLoader__vYAtv","spin":"inlineLoader_spin__iMjhq"};